module.exports = __webpack_public_path__ + "bbbcc84fb4d35ba41965cdd7e48e8917.png";